import { Box, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  CreateIncidentReport,
  IncidentReportTable
} from 'components/incident-reports'
import {
  Operations as IncidentReportOperations,
  operations as incidentReportOperations
} from 'states/dux/incident-report/operations'
import { Payload as IncidentReportPayload } from 'states/dux/incident-report/types'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { IncidentReport } from 'types/incident-report'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  incidentReport: IncidentReportPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    incidentReport: IncidentReportOperations
  }
}

type AppProps = StateProps & DispatchProps

const TrackedIncidentReportTableFC: React.FC<any> = (props: AppProps) => {
  const { operations, incidentReport } = props
  const navigate = useNavigate()

  React.useEffect(() => {
    // Fetch incident reports
    if (incidentReport.data.length < 1) {
      operations.incidentReport.loading(true)
      void get('/report/').then((data: IncidentReport[]) => {
        if (data.length > 0) {
          const parsedData = data.map(report => {
            return objectifyDateStringFields(report)
          })
          operations.incidentReport.set(parsedData)
        }
        operations.incidentReport.loading(false)
      })
    }
  }, [])

  return (
    <Box display={'flex'} flexDirection={'column'} padding={4}>
      <Box display={'flex'} alignItems={'center'} paddingRight={4}>
        <Typography variant={'h4'} padding={2} paddingY={6} paddingRight={4}>
          TRACKED REPORTS
        </Typography>
        <CreateIncidentReport />
      </Box>
      <Box display={'flex'} overflow={'hidden'} padding={1} margin={1}>
        <IncidentReportTable
          incidentReports={incidentReport.data.filter(i => i.tracked)}
          loading={incidentReport.loading}
          onView={id => navigate(`/incident-reports/${id}`)}
        />
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    incidentReport: state.incidentReport
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  incidentReport: incidentReportOperations
})

const TrackedIncidentReportTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackedIncidentReportTableFC)

export default TrackedIncidentReportTable
